angular.module("app").controller("ManagePossibleCancellationsPageController", [
    '$scope',
    '$q',
    'casinoGameService',
    'errorHandler',
    'logger',
    '$uibModalInstance',
    'pageStatuses',
    'skinService',
    'gameName',
    'gameId',
    'skins',
    'casinoJobService',
    function ($scope, $q, casinoGameService, errorHandler, logger, $modalInstance, pageStatuses, skinService, gameName, gameId, skins,casinoJobService) {
        $scope.gameName = gameName;
        var isInitialized = false;
        var preloadedSkinsList;
        var preloadedGameData;
        var attached = [];
        var detached = [];

        $scope.save = function () {
            if (attached.length === 0 && detached.length === 0) {
                logger.logError("global.no_changes");
                return;
            }
            var requestData = {switchSkinsForGame: {game_id: gameId, attached: attached, detached: detached}};

            casinoGameService.switchSkins(requestData).then(
                function (response) {
                    if (response.status === 'ok') {
                        logger.logSuccess("updated");
                        preloadedGameData.skins = angular.copy($scope.gameData.skins);
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        /**
         * Init for per skin
         */
        $scope.initPerSkin = function initPerSkin(){
            preloadedGameData = {skins:skins}
            preloadedSkinsList = {skins:{}};
            $q.all([preloadedGameData, preloadedSkinsList]).then(init, init);
        };

        function init() {

            $scope.allQuery = "";
            $scope.existingQuery = "";
            $scope.gameData = angular.copy(preloadedGameData);

            $scope.skinsList = [];
            $scope.isChanged = false;
            $scope.gameData.skins.map(function (item) {
                item.checked = true;
            });
            $scope.addedItemsCount =  $scope.gameData.skins.length;
            $scope.addingItemsCount = $scope.skinsList.length>0?$scope.skinsList.length - $scope.addedItemsCount:0;
            $scope.addSelected = function () {
                var count = 0;
                $scope.skinsList.forEach(function (item,i) {
                    if (item.checked) {
                        item.checked = false;
                        $scope.gameData.skins.push({name: item.name, id: item.id, checked: false});
                        var detachedIndex = detached.indexOf(item.id);
                        if (detachedIndex === -1) {
                            attached.push(item.id);
                        }
                        if (detachedIndex !== -1){
                            detached.splice(detachedIndex, 1);
                        }
                        ++count;
                        $scope.skinsList.splice(i, 1);
                    }
                });
                $scope.addingItemsCount -= count;
                $scope.addedItemsCount += count;
                $scope.state.selectAllForAddModel = false;
            };

            $scope.removeSelected = function () {
                var count  = 0;
                for (var l = $scope.gameData.skins.length, i = l -1; i >= 0; --i) {
                    var skin = $scope.gameData.skins[i];
                    $scope.skinsList.push({name: skin.name, id: skin.id, checked: false});
                    if (skin.checked) {
                        $scope.gameData.skins.splice(i, 1);
                        ++count;
                        var attachedIndex = attached.indexOf(skin.id);
                        if (attachedIndex === -1) {
                            detached.push(skin.id);
                        }
                        if (attachedIndex !== -1) {
                            attached.splice(attachedIndex, 1);
                        }
                    }
                }
                $scope.addingItemsCount += count;
                $scope.addedItemsCount -= count;
                $scope.state.selectAllForRemoveModel = false;
            };

            $scope.filterForAdd = function (skin) {
                var item  = getItemFromList($scope.allQuery, [skin]);
                return (item || item === null) && (!function () {
                    for (var i = 0, length = $scope.gameData.skins.length; i < length; i++) {
                        if ($scope.gameData.skins[i].id === skin.id) {
                            return true
                        }
                    }
                    return false
                }())
            };

            $scope.filterForRemove = function (skin) {
                var item  = getItemFromList($scope.allQuery, [skin]);
                return (item || item === null)
            };



            function getItemFromList (filterQuery, list) {
                if (!!filterQuery) {
                    for (var i = 0, length = list.length, regex = new RegExp("^" + filterQuery); i < length; i++) {
                        if (list[i].name.toLowerCase().indexOf(filterQuery.toLowerCase()) !== -1 || regex.test(list[i].id)) {
                            return true
                        }
                    }
                } else {
                    return null
                }
                return false
            }


            $scope.getSelectedForAddCount = function () {
                return $scope.skinsList.reduce(function (prev, current) {
                    return prev + (current.checked? 1: 0);
                }, 0)
            };

            $scope.getSelectedForDeleteCount = function () {
                return $scope.gameData.skins.reduce(function (prev, current) {
                    return prev + (current.checked? 1: 0);
                }, 0)
            };
            $scope.state = {
                selectAllForAddModel: false,
                selectAllForRemoveModel: true
            };

            /**
             * Select all for add
             */
            $scope.selectAllForAdd = function () {
                $scope.skinsList.forEach(function (item) {
                    if($scope.filterForAdd(item)) {
                        item.checked = $scope.state.selectAllForAddModel;
                    }
                });
            }
            /**
             * Select all for remove
             */
            $scope.selectAllForRemove = function () {
                $scope.gameData.skins.forEach(function (item) {
                    if ($scope.filterForRemove(item)) {
                        item.checked = $scope.state.selectAllForRemoveModel;
                    }
                });
            }
            /**
             * Recalculate counts of sections
             */
            $scope.recalculateCounts = function () {
                var count1 = 0;
                var count2 = 0;
                $scope.gameData.skins.forEach(function (item) {
                    if ($scope.filterForRemove(item)) {
                        ++count1;
                    }
                });
                $scope.addedItemsCount = count1;
                $scope.skinsList.forEach(function (item) {
                    if ($scope.filterForAdd(item)) {
                        ++count2;
                    }
                });
                $scope.addingItemsCount = count2;
            };
            isInitialized = true;
        }

        $scope.initPerSkin();


    }
]);